import { injectable, inject } from 'inversify';
import Debug from 'debug';
import { QuizSessionServiceSymbol, QuizSessionService } from '@/app/quiz-session/service';
import { StartPracticeSessionCommand, UpdatePracticeSessionQuestionStateCommand, UpdatePracticeSessionNavigationCommand,
         StartPracticeSessionCommandPayload, UpdatePracticeSessionQuestionStateCommandPayload,
         UpdatePracticeSessionNavigationCommandPayload, UpdatePracticeSessionQuestionTimesCommand,
         UpdatePracticeSessionQuestionTimesCommandPayload } from '../domain';

const debug = Debug('practice-session-service')

export const PracticeSessionServiceSymbol = Symbol.for('PracticeSessionService')

@injectable()
export class PracticeSessionService {

  constructor(
    @inject(QuizSessionServiceSymbol)
    private quizSessionService: QuizSessionService) {
  }
  
  startSession(sessionId: string, practiceId: string, aspect: string,
               details: StartPracticeSessionCommandPayload) {

    debug('start-session', sessionId, practiceId, details)

    const command: StartPracticeSessionCommand = {
      name: 'start-practice-session',
      payload: {
        questionIds: details.questionIds,
        questionIndex: details.questionIndex,
        levelBefore: details.levelBefore
      }
    }
    
    this.quizSessionService.startSession<StartPracticeSessionCommand>(sessionId, practiceId, aspect, 'practice',
                                                                      command)
  }

  updateQuestionState(sessionId: string, details: UpdatePracticeSessionQuestionStateCommandPayload) {
    debug('update-question-state', sessionId, details)

    const command: UpdatePracticeSessionQuestionStateCommand = {
      name: 'update-practice-session-question-state',
      payload: details
    }
    
    this.quizSessionService.updateSession<UpdatePracticeSessionQuestionStateCommand>(sessionId, command)
  }

  updateNavigation(sessionId: string, details: UpdatePracticeSessionNavigationCommandPayload) {
    debug('update-navigation', sessionId, details)

    const command: UpdatePracticeSessionNavigationCommand = {
      name: 'update-practice-session-navigation',
      payload: details
    }

    this.quizSessionService.updateSession<UpdatePracticeSessionNavigationCommand>(sessionId, command)
  }

  updateQuestionTimes(sessionId: string, details: UpdatePracticeSessionQuestionTimesCommandPayload) {
    debug('update-question-times', sessionId, details)

    const command: UpdatePracticeSessionQuestionTimesCommand = {
      name: 'update-practice-session-question-times',
      payload: details
    }

    this.quizSessionService.updateSession<UpdatePracticeSessionQuestionTimesCommand>(sessionId, command)
  }

  finishSession(sessionId: string) {
    debug('finish-session', sessionId)

    this.quizSessionService.finishSession(sessionId)
  }

  abortSession(sessionId: string) {
    debug('abort-session', sessionId)

    this.quizSessionService.abortSession(sessionId)
  }
}
